import { Button } from "primereact/button";

const RoundedButton = ({
  label = "Guardar",
  color = "success",
  handleClick,
  disabled = false,
  outlined = false,
  tooltip = "",
  id = "rounded-button",
  ...props
}) => {
  return (
    <Button
      title={tooltip}
      tooltipOptions={{ position: "top" }}
      type="button"
      label={label}
      className={
        "p-button-rounded p-button-" +
        color +
        (outlined ? " p-button-outlined" : "")
      }
      style={{
        maxWidth: "15rem",
        height: "2.2rem",
        fontWeight: "500!important",
        padding: "0.4rem 0.8rem",
      }}
      onClick={handleClick}
      disabled={disabled}
      aria-label="rounded-button"
      id={id}
      {...props}
    />
  );
};

export default RoundedButton;
